import {PageError403} from '@/pages/Errors/403'
import {PageError500} from '@/pages/Errors/500'
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'
import {ProtectedRoutes} from './ProtectedRoutes'
import {setShellActive, setShellPath} from '@/store/slices/commonSlice'
import {
  PageError404,
  AddSalesTargetProduct,
  PointMultiplier,
  StoreName,
  OrderDetail,
  DynamicTable,
  OnlineOrder,
  OrderItemOverview,
  ProductList,
  OnlineItems,
  TestPage,
  Fullfillment,
} from '@/pages'
import {useAppDispatch} from '@/store'
import {useEffect} from 'react'
import {ImageOptimization} from '@/containers/ImageOptimization'
import {useSelector} from 'react-redux'
import {UserDetails} from '@/services/UserDetails'
import {setUserDetails} from '@/store/slices/userSlice'
import {isObjectNotEmpty} from '@/helpers/shadcn/utils'

const productRoutes = [
  {path: ROUTES.ADD_SALES_PRODUCT, element: <AddSalesTargetProduct />},
  {path: ROUTES.PRODUCTS_LIST, element: <ProductList />},
]
const orderRoutes = [
  {path: ROUTES.ORDER_DETAIL_PAGE, element: <OrderDetail />},
  {path: ROUTES.ORDER_LIST, element: <OnlineOrder />},
  {path: ROUTES.ORDER_ITEM, element: <OnlineItems />},
  {path: ROUTES.ORDER_ITEM_OVERVIEW, element: <OrderItemOverview />},
]  

const imageRoutes = [{path: ROUTES.IMAGE, element: <ImageOptimization />}]

const fullfillmentRoutes = [{path: ROUTES.FULLFILLMENT, element: <Fullfillment />}]
const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [
      { path: ROUTES.HOME, element: <ProductList /> },
      ...productRoutes,
      ...orderRoutes,
      ...imageRoutes,
      ...fullfillmentRoutes,

      /* Errors */
      { path: ROUTES.ERROR_500, element: <PageError500 /> },
      { path: ROUTES.ERROR_403, element: <PageError403 /> },
      { path: '*', element: <PageError404 /> },

      /* Test */
      { path: ROUTES.TEST, element: <TestPage /> },
    ],
  },
])


export const AppRouter = ({shellActive, darkTheme, path}) => {
  const dispatch = useAppDispatch()
  const userData = useSelector(state => state?.userDetails)
  const getUserData = async () => {
    if (!isObjectNotEmpty(userData)) {
      try {
        await UserDetails()
        const reqData = {
          name: 'Robert',
          role: ['admin', 'super-admin'],
          country: [{name: 'Mexico', lang: [{langcode: 33, name: 'mexico'}]}],
          countryCode: 'mx',
          siteId: 21,
        }
        dispatch(setUserDetails(reqData))
      } catch {
        console.log('Error')
        const reqData = {
          name: 'Louis',
          role: ['admin'],
          country: [{name: 'Turkey', lang: [{langcode: 31, name: 'Turkey'}]}],
          countryCode: 'TR',
          siteId: 23,
        }
        dispatch(setUserDetails(reqData))
      }
    }
  }
  useEffect(() => {
    getUserData()
  })
  useEffect(() => {
    dispatch(setShellActive(shellActive))
  }, [shellActive, dispatch])

  useEffect(() => {}, [darkTheme])

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path))
  })

  return <RouterProvider router={router} />
}
